import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
  baseStyles,
  BORDER_RADIUS,
  CONTAINER_SPACE,
  CONTAINER_SPACE_TOP,
  CONTAINER_SPACE_XS,
  CONTENT_MAX_WIDTH,
  FIELD_SPACE,
  FIELD_SPACE_XS,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import {
  ColorField,
  ColorFieldBorder,
  ColorFieldBorderHover,
  ColorOtherTitle,
  ColorSubTitle,
  ColorTheme,
  ColorTitle,
  ColorTitleLite,
  ColorWhite
} from "src/styles/Colors";
import {
  fetchActivityInsight,
  fetchActivityInsightConfigs,
  resetActivityInsight,
  sortActivityInsight,
  toggleShowHideQnsInActivityInsight,
  toggleZeroInActivityInsight
} from "src/js/actions/activitiesActions";
import {ErrorViewEx, ImageIcon} from "src/js/components/commons/ViewHelper";
import {getURLParameters, navBackOrExit} from "src/js/components/routes/NavHelper";
import HeaderTitleView from "src/js/components/commons/HeaderTitleView";
import {Button, FormControl, IconButton} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {FormattedMessage} from "react-intl";
import Space from "src/js/components/commons/Space";
import TextView from "src/js/components/commons/TextView";
import FieldSpace from "src/js/components/commons/FieldSpace";
import {FontWeightMedium, FontWeightRegular} from "src/res/FontWeight";
import DialogView from "src/js/components/commons/DialogView";
import InsightFilterScreen from "src/js/components/insight/InsightFilterScreen";
import InsightFilterHelper, {
  FILTER_INTEREST_OPTION,
  FILTER_TYPE_DATE
} from "src/js/components/insight/InsightFilterHelper";
import DateTimeHelper from "src/js/utils/DateTimeHelper";
import AppUtils from "src/js/utils/AppUtils";
import View from "src/js/components/commons/View";
import ValueHelper from "src/js/utils/ValueHelper";
import TouchableOpacity from "src/js/components/commons/TouchableOpacity";
import AppText from "src/js/components/commons/AppText";
import Paper from "@material-ui/core/Paper";
import {
  SORT_BY_LABEL_ASC,
  SORT_BY_LABEL_DESC,
  SORT_BY_VALUE_ASC,
  SORT_BY_VALUE_DESC
} from "src/js/reducers/activitiesReducer";
import {fetchScreenInsight, fetchScreenInsightConfigs} from "src/js/actions/showcaseActions";

const useStyles = (theme) => ({
  mainContainer: {
    flex: 1,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: CONTAINER_SPACE_TOP,
    paddingBottom: CONTAINER_SPACE,
    overflowX: 'hidden',
    [theme.breakpoints.down('xs')]: {
      paddingTop: 4,
      paddingBottom: CONTAINER_SPACE_XS,
    },
  },
  mainContainerInner: {
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    maxWidth: CONTENT_MAX_WIDTH,
    marginRight: -CONTAINER_SPACE,
    marginLeft: -CONTAINER_SPACE,
    paddingLeft: CONTAINER_SPACE,
    paddingRight: 4,
    [theme.breakpoints.down('xs')]: {
      marginRight: -CONTAINER_SPACE_XS,
      marginLeft: -CONTAINER_SPACE_XS,
      paddingLeft: CONTAINER_SPACE_XS,
      paddingRight: CONTAINER_SPACE_XS,
    },
  },
  selectWrapper: {
    display: 'flex',
    flex: 1,
    maxWidth: 420,
    minWidth: 180,
    marginRight: FIELD_SPACE,
    marginBottom: FIELD_SPACE,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 600,
      flex: 0,
      marginRight: 0,
      marginBottom: 12,
    }
  },
  selectView: {
    maxWidth: 420,
    maxHeight: 50,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 600,
    }
  },
  selectMenu: {
    whiteSpace: 'normal',
    minHeight: 40,
    maxWidth: 420,
    maxHeight: 50,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 600,
    }
  },
  filterWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    maxWidth: 420,
    minWidth: 140,
    minHeight: 50,
    maxHeight: 50,
    marginRight: FIELD_SPACE,
    marginBottom: FIELD_SPACE,
    backgroundColor: ColorField,
    border: '1px solid '+ ColorFieldBorder,
    borderRadius: BORDER_RADIUS,
    '&:hover': {
      backgroundColor: ColorField,
      border: '1px solid '+ ColorFieldBorderHover,
    },
    [theme.breakpoints.down('md')]: {
      flex: 0.7,
    },
    [theme.breakpoints.down('xs')]: {
      flex: 0,
      maxWidth: 600,
      minWidth: 50,
      marginRight: 0,
      marginBottom: 12,
    }
  },
  buttonInsight: {
    display: 'flex',
    flex: 1,
    minWidth: 140,
    minHeight: 48,
    maxHeight: 48,
    maxWidth: 420,
    marginRight: FIELD_SPACE,
    marginBottom: FIELD_SPACE,
    [theme.breakpoints.down('md')]: {
      flex: 0.7,
    },
    [theme.breakpoints.down('xs')]: {
      flex: 0,
      maxWidth: 600,
      marginRight: 0,
      marginBottom: FIELD_SPACE_XS,
    }
  },
  chartWrapper: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    marginRight: FIELD_SPACE,
    marginBottom: FIELD_SPACE,
    // maxWidth: FORM_WIDE_MAX_WIDTH,
    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
      marginBottom: FIELD_SPACE_XS,
      // maxWidth: MAX_WIDTH_XS,
    }
  }
});

export const getScreenInsightNavPath = (id) => {
  return {pathname: '/screens/insight/'+ id, search: '?s=1'}
}

export const getActivityInsightNavPath = (id, type, showRating) => {
  return {pathname: '/campaigns/insight/'+ id, search: `?at=${type}${showRating ? '&sr=1' : ''}`}
}

export const getActivityReviewsNavPath = (id) => {
  return {pathname: '/campaigns/reviews/'+ id}
}

class ActivityInsight extends React.Component {

  constructor(props) {
    super(props);

    this.activity = null;
    this.activityId = null;
    this.activityType = null;
    this.showRating = null;
    const {location} = this.props;
    let path = location.pathname;
    path = path.replace('/campaigns/insight/', '');
    path = path.replace('/screens/insight/', '');
    if (path && path.length > 0) {
      this.activityId = path;
    }
    this.isScreen = getURLParameters(location.search)['s'];
    this.activityType = getURLParameters(location.search)['at'];
    this.showRating = getURLParameters(location.search)['sr'];
    if (location.state) {
      this.activity = location.state.model;
    }

    this.state = {
      chartId: '',
      focusId: '',
      subFocusId: '',
      filters: null,
      showFilters: false,
    };
  }

  componentDidMount() {
    document.title = this.isScreen ? 'Rab7 | Display Insight' : 'Rab7 | Campaign Insight';

    this.makeApiForInsightConfig();
  }

  reloadView() {
    this.setState({reload: !this.state.reload});
  }

  render() {
    const {app, classes, isLoading, activityInsight, isXS, isDrawerHidden} = this.props;
    const {chartId, focusId, subFocusId, filters, showFilters} = this.state;

    // const viewHeader = <HeaderTitleView isLTR={app.isLTR} isXS={isXS} titleId={'activity.insight'} onBackClicked={!isDrawerHidden ? this.onBackClicked : null}/>
    if (isLoading) {
      return null; // viewHeader;
    }

    const viewSelectChart = activityInsight.configs ? (
      <FormControl
        fullWidth
        required
        variant="filled"
        size="small"
        className={classes.selectWrapper}>
        <InputLabel id="selectChartLabelId" htmlFor="selectChart"><FormattedMessage id={'activity.selectChart'} /></InputLabel>
        <Select
          disableUnderline={true}
          id="selectChart"
          labelId="selectChartLabelId"
          value={chartId}
          onChange={this.onChangeSelect}
          name={'chartId'}
          className={classes.selectView}>
          {activityInsight.configs.charts.map((item) => {
            return (
              <MenuItem value={item.id} dense className={classes.selectMenu}>
                <TextView
                  fontSizeN={15}
                  numberOfLines={2}
                  variant={'body1'}
                  color={ColorTitle}>
                  {item.name}
                </TextView>
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    ) : null;

    const viewSelectFocus = activityInsight.configs ? (
      <FormControl
        fullWidth
        required
        variant="filled"
        size="small"
        className={classes.selectWrapper}>
        <InputLabel id="selectFocusLabelId" htmlFor="selectFocus"><FormattedMessage id={'activity.selectFocus'} /></InputLabel>
        <Select
          size="small"
          disableUnderline={true}
          id="selectFocus"
          labelId="selectFocusLabelId"
          value={focusId}
          onChange={this.onChangeSelect}
          name={'focusId'}
          className={classes.selectView}>
          {activityInsight.configs.focuses.map((group, groupIndex) => {
            if (group.inCharts && group.inCharts.length > 0 && (!chartId || !group.inCharts.includes(chartId))) {
              return null;
            }

            const views = [];
            views.push(
              <div style={{padding: 16, paddingTop: groupIndex > 0 ? 24 : 0, paddingBottom: 4}}>
                <TextView
                  variant={'caption'}
                  color={ColorOtherTitle}
                  fontWeight={FontWeightMedium}>
                  {group.name}
                </TextView>
              </div>
            );
            group.items.forEach((item) => {
              views.push(
                <MenuItem value={item.id} dense className={classes.selectMenu}>
                  <TextView
                    fontSizeN={15}
                    numberOfLines={2}
                    variant={'body1'}
                    color={ColorTitle}>
                    {item.name}
                  </TextView>
                </MenuItem>
              );
            })
            return views;
          })}
        </Select>
      </FormControl>
    ) : null;

    const appliedFiltersCount = this.getAppliedFiltersCount(filters);
    const viewFilterCount = filters && appliedFiltersCount > 0 ? (
      <div style={{borderRadius: '50%', minWidth: 18, minHeight: 18, padding: 5, paddingTop: 0, paddingBottom: 0, backgroundColor: ColorTitle, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <TextView variant={'caption'} fontWeight={FontWeightMedium} color={ColorWhite}>{appliedFiltersCount}</TextView>
      </div>
    ) : null;
    const viewFilter = isXS ? (
      <div className={classes.filterWrapper}>
        <IconButton
          onClick={this.onFiltersClicked}
          color={'secondary'}
          style={{width: 48, height: 48, borderRadius: BORDER_RADIUS}}>
          <div style={{minWidth: 48, minHeight: 48, width: 48, height: 48, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <ImageIcon src={require('src/images/ic_filter.png')} width={20} />
            <div style={{position: 'absolute', top: 4, right: 4}}>
              {viewFilterCount}
            </div>
          </div>
        </IconButton>
      </div>
    ) : (
      <div className={classes.filterWrapper}>
        <Button
          onClick={this.onFiltersClicked}
          fullWidth={true}
          color={'secondary'}>
          <div className={classes.flexRow}>
            <Space vertical={4}/>
            <FormattedMessage id={'activity.filters'}/>
            <Space vertical={8}/>
            {viewFilterCount}
          </div>
        </Button>
        <IconButton
          onClick={this.onFiltersDeleted}
          color={'secondary'}
          style={{width: 48, height: 48, opacity: appliedFiltersCount > 0 ? 1 : 0}}>
          <ImageIcon src={require('src/images/ic_delete.png')}/>
        </IconButton>
      </div>
    );
    let topViews = null;
    if (isXS) {
      topViews = (
        <div className={classes.viewRowFullWidthNoCenter} style={{alignItems: 'flex-end'}}>
          <div className={classes.viewColumnFullWidthNoCenter} style={{marginRight: app.isLTR ? 8 : 0, marginLeft: app.isLTR ? 0 : 8, maxWidth: window.appWidth - 90}}>
            {viewSelectChart}
            <Space top={-4} />
            {viewSelectFocus}
          </div>
          <div className={classes.viewColumn}>
            <div className={classes.filterWrapper} style={{marginBottom: 8}}>
              <IconButton
                onClick={this.onResetClicked}
                color={'secondary'}
                style={{width: 48, height: 48, borderRadius: BORDER_RADIUS}}>
                <div style={{minWidth: 48, minHeight: 48, width: 48, height: 48, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                  <ImageIcon src={require('src/images/ic_reset.png')} width={20} />
                </div>
              </IconButton>
            </div>
            {viewFilter}
          </div>
        </div>
      );
    } else {
      topViews = [viewSelectChart, viewSelectFocus, viewFilter];
    }

    return (
      <div className={classes.mainContainer}>
        <HeaderTitleView isLTR={app.isLTR} isXS={isXS} titleId={this.isScreen ? 'screen.screenInsight' : 'activity.campaignInsight'} onBackClicked={!isDrawerHidden ? this.onBackClicked : null}/>
        <div className={classes.mainContainerInner}>
          {/*{this.activity ?*/}
          {/*  <SectionHeaderView label={null} subLabelId={this.activity.title} marginBottom={16}/>*/}
          {/*  : null*/}
          {/*}*/}
          {activityInsight.configs ?
            <div className={classes.viewColumnFullWidthNoCenter1}>
              <div className={isXS ? classes.viewColumnFullWidthNoCenter1 : classes.viewFullWidthWrap}>
                {topViews}
                <Button
                  disabled={!chartId || !focusId}
                  disableElevation={true}
                  fullWidth
                  variant={'contained'}
                  color={'primary'}
                  className={classes.buttonInsight}
                  onClick={this.onShowInsightClicked}>
                  <FormattedMessage id={'activity.showInsight'}/>
                </Button>
              </div>
              {this.renderFilters()}

              <FieldSpace />
              {this.renderCharts()}
            </div>
            : null
          }
          {activityInsight.errMsgF || activityInsight.errMsg ?
            <ErrorViewEx
              classes={classes}
              error={activityInsight.errMsg || this.context.intl.formatMessage({id: activityInsight.errMsgF})}
              onRetryClicked={this.onRetryClicked}
            />
            : null
          }
        </div>
      </div>
    );
  }

  renderFilters() {
    const {activityInsight} = this.props;
    const {filters, showFilters} = this.state;

    const filterView = <InsightFilterScreen ref={(ref) => this.refFilterView = ref} filters={activityInsight.configs.filters} appliedFilters={filters} onResult={this.onFiltersUpdated}/>
    return (
      <DialogView
        show={showFilters}
        renderContent={() => {
          return filterView;
        }}
        fullScreen
        transparent
        noSpace
      />
    );
  }

  renderCharts() {
    const {classes, isXS} = this.props;
    const {activityInsight} = this.props;
    if (!activityInsight.data || activityInsight.data.length === 0) {
      return null;
    }

    return (
      <div className={isXS ? classes.viewColumnFullWidthNoCenter1 : classes.viewFullWidthWrap}>
        {activityInsight.data.map((item, index) => {
          return (
            <div className={classes.chartWrapper} style={{width: activityInsight.data.length === 1 || isXS ? '100%' : '50%'}}>
              {this.getChart(item, index)}
            </div>
          );
        })}
      </div>
    );
  }

  getAppliedFiltersCount = (filterObj) => {
    let filtersCount = 0;
    if (filterObj) {
      const filters = Object.keys(filterObj);
      filtersCount = filters.length;
      if (filters.includes(FILTER_INTEREST_OPTION)) {
        filtersCount--;
      }
    }
    return filtersCount;
  }

  getChart(data, dataIndex) {
    if (data.type === 1) {
      return this.getStackBarXChart(data, dataIndex);
    }
    return this.getBarXChart(data, dataIndex);
  }

  getBarXChart(data, dataIndex) {
    const {app, classes} = this.props;

    let values = data.values;
    const excludeZero = data.excludeZero;
    const showQns = data.showQns;
    const isAverageChart = data.subType === 1;
    const isPercentChart = data.subType === 2;
    const isFocusActivityQuestions = (data.chart === 7 || data.chart === 8 || data.chart === 12) && data.focus === 86;

    const backColor = 'rgba(221,234,255,0.15)';
    const foreColor = 'rgba(221,234,255,1)';
    data.total = 0;
    data.avg = 0;
    let barViews = null;
    if (values) {
      let index = 0;
      values.forEach((item) => {
        data.total += item.value;
        if (index === 0) {
          data.avg = item.value;
        } else {
          data.avg = (data.avg * index + item.value) / (index + 1);
        }
        index++;
      });

      barViews = [];
      for (let i = 0; i < values.length; i++) {
        const item = values[i];
        if (excludeZero && !item.value) {
          continue;
        }
        let progress = 0;
        if (isPercentChart || isAverageChart) {
          if (data.inputCount > 0) {
            progress = item.value / data.inputCount;
          }
        } else {
          if (data.total > 0) {
            progress = item.value / data.total;
          }
        }
        const percentage = Math.min(progress * 100, 100);
        const decimal = percentage > 10.0 ? 0 : 1;
        let percentageText = ValueHelper.getDisplayValue(percentage, decimal, true, false) + "%";
        let valueText = ValueHelper.getDisplayValue(item.value, isAverageChart ? 1 : 0, true, false);
        if (isPercentChart) {
          valueText = percentageText;
          percentageText = null;
        }
        if (isAverageChart) {
          percentageText = null;
        }
        if (isFocusActivityQuestions) {
          percentageText = null;
        }
        const barView = <View className={classes.viewColumnFullWidthNoCenter1} style={{backgroundColor: backColor, marginTop: 6, borderRadius: BORDER_RADIUS, position: 'relative'}}>
          <View style={{position: 'absolute', left: 0, top: 0, bottom: 0, width: `${percentage}%`, backgroundColor: foreColor, borderRadius: BORDER_RADIUS}} />
          <TouchableOpacity disabled={true} style={{opacity: 1}} onClick={() => this.onBarItemClicked(item)}>
            <View className={classes.viewRowFullWidth} style={{paddingLeft: 8, paddingRight: 8, paddingTop: 4, paddingBottom: 4}}>
              <AppText variant={'body2'} numberOfLines={2} style={{align: 'left', flex: 1, color: ColorTitle, fontWeight: FontWeightMedium, whiteSpace: 'collapse'}}>
                {isFocusActivityQuestions && !showQns ? item.label.substring(0, item.label.indexOf('-')) : ''+ item.label}
              </AppText>
              <AppText style={{color: ColorTitle, fontWeight: FontWeightMedium}}>
                {valueText}
              </AppText>
              {percentageText ?
                <React.Fragment>
                  <Space vertical={6}/>
                  <AppText variant={'caption'} style={{textAlign: app.isLTR ? 'right' : 'left', color: ColorTheme, fontWeight: FontWeightMedium, minWidth: 40}}>
                    {percentageText}
                  </AppText>
                </React.Fragment>
                : null
              }
            </View>
          </TouchableOpacity>
        </View>;
        barViews.push(barView);
      }
    }

    return this.getBarWrapperView(data, dataIndex, barViews);
  }

  getStackBarXChart(data, dataIndex) {
    const {app, classes} = this.props;

    let values = data.values;
    const showQns = data.showQns;
    const excludeZero = data.excludeZero;
    const isAverageChart = data.subType === 1;
    const isPercentChart = data.subType === 2;
    const isFocusActivityQuestions = (data.chart === 7 || data.chart === 8 || data.chart === 12) && data.focus === 86;

    const backColor = 'rgba(221,234,255,0.15)';
    data.total = 0;
    let barViews = null;
    if (values) {
      values.forEach((item) => {
        data.total += item.value;
        item.total = 0;
        if (item.values) {
          item.values.forEach((subValue) => {
            item.total += subValue.value;
          });
        }
      });

      barViews = [];
      for (let i = 0; i < values.length; i++) {
        const item = values[i];
        if (excludeZero && !item.value) {
          continue;
        }
        let progress = 0;
        if (data.total > 0) {
          progress = item.value / data.total;
        }
        const percentage = Math.min(progress * 100, 100);

        let barChildViews = null;
        const subValues = item.values;
        if (subValues) {
          barChildViews = [];

          for (let i = 0; i < subValues.length; i++) {
            const subValue = subValues[i];
            const value = subValue.value;
            if (excludeZero && !value) {
              continue;
            }

            const label = subValue.label;
            let progress = 0;
            if (item.total > 0) {
              progress = value / item.total;
            }
            const subPercentage = Math.min(progress * 100, 100);
            let subPercentageText = ValueHelper.getDisplayValue(subPercentage, subPercentage > 10.0 ? 0 : 1, true, false) + "%";
            let subValueText = ValueHelper.getDisplayValue(value, isAverageChart ? 1 : 0, true, false);
            let foreColor = 'rgba(221,234,255,1)';
            if (subValue.isCG) {
              foreColor = '#a2efa6';
            }

            const view = <View className={classes.viewColumnFullWidthNoCenter1} style={{paddingLeft: app.isLTR ? 30 : 0, paddingRight: !app.isLTR ? 30 : 0, marginTop: 1, marginBottom: 2, borderRadius: BORDER_RADIUS, position: 'relative'}}>
              <View className={classes.viewColumnFullWidthNoCenter1} style={{position: 'relative'}}>
                <View style={{position: 'absolute', left: 0, top: 0, bottom: 0, width: `${subPercentage}%`, backgroundColor: foreColor, borderRadius: BORDER_RADIUS}} />
                <TouchableOpacity disabled={true} style={{opacity: 1}} onClick={() => this.onBarItemClicked(item)}>
                  <View className={classes.viewRowFullWidth} style={{paddingLeft: 8, paddingRight: 8, paddingTop: 4, paddingBottom: 4}}>
                    <AppText variant={'body2'} numberOfLines={2} style={{align: 'left', flex: 1, color: ColorTitle, fontWeight: FontWeightRegular, whiteSpace: 'collapse'}}>
                      {isFocusActivityQuestions && !showQns ? label.substring(0, label.indexOf('-')) : ''+ label}
                    </AppText>
                    <AppText variant={'body2'} style={{color: ColorTitle, fontWeight: FontWeightRegular}}>
                      {subValueText}
                    </AppText>
                    {subPercentageText ?
                      <React.Fragment>
                        <Space vertical={6}/>
                        <AppText variant={'caption'} color={AppUtils.colorWithAlpha(ColorTheme, 0.9)} style={{textAlign: app.isLTR ? 'right' : 'left', fontWeight: FontWeightRegular, minWidth: 40}}>
                          {subPercentageText}
                        </AppText>
                      </React.Fragment>
                      : null
                    }
                  </View>
                </TouchableOpacity>
              </View>
            </View>
            barChildViews.push(view);
          }
        }

        let valueText = ValueHelper.getDisplayValue(item.value, isAverageChart ? 1 : 0, true, false);
        // let percentageText = ValueHelper.getDisplayValue(percentage, percentage > 10.0 ? 0 : 1, true, false) + "%";
        let percentageText = null;
        const barView =
          <View className={classes.viewColumnFullWidthNoCenter1} style={{backgroundColor: backColor, marginTop: 6, borderRadius: BORDER_RADIUS, position: 'relative'}}>
            <TouchableOpacity disabled={true} onPress={() => this.onBarItemClicked(item)} style={{opacity: 1}}>
              <View className={classes.viewColumnFullWidthNoCenter1}>
                <View className={classes.viewRowFullWidth} style={{paddingLeft: 8, paddingRight: 8, paddingTop: 4, paddingBottom: 4, position: 'relative'}}>
                  {/*<View style={{position: 'absolute', left: 0, top: 0, bottom: 0, width: `${percentage}%`, backgroundColor: foreColor, borderRadius: BORDER_RADIUS}} />*/}
                  <AppText variant={'body2'} numberOfLines={2} style={{align: 'left', flex: 1, color: ColorTitle, fontWeight: FontWeightMedium, whiteSpace: 'collapse'}}>
                    {isFocusActivityQuestions && !showQns ? item.label.substring(0, item.label.indexOf('-')) : ''+ item.label}
                  </AppText>
                  <AppText style={{color: ColorTitle, fontWeight: FontWeightMedium}}>
                    {valueText}
                  </AppText>
                  {percentageText ?
                    <React.Fragment>
                      <Space vertical={6}/>
                      <AppText variant={'caption'} style={{textAlign: app.isLTR ? 'right' : 'left', color: ColorTheme, fontWeight: FontWeightMedium, minWidth: 40}}>
                        {percentageText}
                      </AppText>
                    </React.Fragment>
                    : null
                  }
                </View>
                {barChildViews}
              </View>
            </TouchableOpacity>
          </View>;
        barViews.push(barView);
      }
    }

    return this.getBarWrapperView(data, dataIndex, barViews);
  }

  getBarWrapperView(data, dataIndex, barViews) {
    const {classes, isXS} = this.props;

    const sortBy = data.sortBy;
    const excludeZero = data.excludeZero;
    const showQns = data.showQns;
    let sortByLabelOpacity = 0.5;
    let sortByValueOpacity = 0.5;
    if (sortBy === SORT_BY_LABEL_ASC || sortBy === SORT_BY_LABEL_DESC) {
      sortByLabelOpacity = 1;
    } else if (sortBy === SORT_BY_VALUE_ASC || sortBy === SORT_BY_VALUE_DESC) {
      sortByValueOpacity = 1;
    }
    const isAverageChart = data.subType === 1;
    const isPercentChart = data.subType === 2;
    const isFocusActivityQuestions = (data.chart === 7 || data.chart === 8 || data.chart === 12) && data.focus === 86;

    let valueText = ValueHelper.getDisplayValue(data.total, 0, true, false);
    if (isPercentChart || isAverageChart || isFocusActivityQuestions) {
      // const percentage = Math.min(data.avg/data.inputCount*100, 100);
      // valueText = ValueHelper.getDisplayValue(percentage, 0, 1) + "%";
      valueText = null;
    }
    return (
      <Paper className={classes.viewColumnFullWidthNoCenter1} style={{backgroundColor: ColorWhite, padding: isXS ? FIELD_SPACE_XS : FIELD_SPACE}}>
        <div className={classes.viewRowFullWidthNoCenter} style={{marginTop: -4, marginBottom: -4}}>
          <div className={classes.viewColumnFullWidthNoCenter}>
            <AppText variant={'h6'} style={{fontWeight: FontWeightMedium, color: ColorTitle}}>{data.label}</AppText>
            <AppText variant={'body2'} style={{fontWeight: FontWeightMedium, color: ColorSubTitle}}>{data.hint}</AppText>
          </div>
          <Space verticalSpace={1}/>
          {valueText ?
            <AppText variant={'h6'} style={{color: ColorTitleLite, fontWeight: FontWeightMedium}}>
              {valueText}
            </AppText>
            : null
          }
          <Space verticalSpace={1}/>
        </div>
        <FieldSpace/>
          {/*{data.hint ?*/}
          {/*    <AppText style={{*/}
          {/*        textAlign: 'center',*/}
          {/*        fontSize: FontSizeXSmall,*/}
          {/*        color: ColorOtherTitle,*/}
          {/*        marginTop: 2}}>*/}
          {/*        {data.hint}*/}
          {/*    </AppText>*/}
          {/*    : null*/}
          {/*}*/}
        <View style={{flexDirection: 'row', paddingTop: 4, paddingBottom: 4, marginLeft: -2, marginRight: -2, marginBottom: -10, marginTop: -8, backgroundColor: 'rgba(0,0,0,0)', borderRadius: BORDER_RADIUS}}>
          <IconButton
            onClick={() => {
              this.props.sortActivityInsight(dataIndex, sortBy === SORT_BY_LABEL_ASC ? SORT_BY_LABEL_DESC : SORT_BY_LABEL_ASC);
            }}>
            <ImageIcon width={16} src={sortByLabelOpacity === 1 ? sortBy === SORT_BY_LABEL_ASC ? require('src/images/ic_arrow_z_a_m.png') : require('src/images/ic_arrow_a_z_m.png') : require('src/images/ic_arrow_a_z.png')} style={{opacity: sortByLabelOpacity}}></ImageIcon>
          </IconButton>
          {isFocusActivityQuestions ?
            <Button style={{fontWeight: FontWeightRegular}} color={'secondary'} onClick={() => this.props.toggleShowHideQnsInActivityInsight(dataIndex)}>
              <FormattedMessage id={showQns ? 'activity.hideQuestions' : 'activity.showQuestions'}/>
            </Button>
            : null
          }
          <View style={{flex: 1}} />
          <IconButton
            onClick={() => {
              this.props.toggleZeroInActivityInsight(dataIndex)
            }}>
            <ImageIcon width={excludeZero ? 16 : 17} src={excludeZero ? require('src/images/ic_zero_slash_m.png') : require('src/images/ic_zero_slash.png')} style={{opacity: excludeZero ? 1 : 0.5}}></ImageIcon>
          </IconButton>
          <IconButton
            onClick={() => {
              this.props.sortActivityInsight(dataIndex, sortBy === SORT_BY_VALUE_ASC ? SORT_BY_VALUE_DESC : SORT_BY_VALUE_ASC);
            }}>
            <ImageIcon width={16} src={sortByValueOpacity === 1 ? sortBy === SORT_BY_VALUE_ASC ? require('src/images/ic_arrow_big_small_m.png') : require('src/images/ic_arrow_small_big_m.png') : require('src/images/ic_arrow_small_big.png')} style={{opacity: sortByValueOpacity}}></ImageIcon>
          </IconButton>
        </View>
        {barViews ?
          <View>
            {barViews}
          </View>
          : null
        }
        {/*{showTotal ?*/}
        {/*  <View style={{flexDirection: 'row', alignItems: 'center', paddingLeft: 8, paddingRight: 8, paddingTop: 4, paddingBottom: 4, marginTop: 8, backgroundColor: totalBgColor, borderRadius: BORDER_RADIUS}}>*/}
        {/*    <AppText numberOfLines={1} style={{align: 'left', flex: 1, color: ColorTitleLite, marginEnd: SpaceNormal, fontWeight: FontWeightBold}}>*/}
        {/*      {locString('total')}*/}
        {/*    </AppText>*/}
        {/*    <AppText style={{color: ColorTitleLite, fontWeight: FontWeightBold}}>*/}
        {/*      {ValueHelper.getDisplayValue(isPercentChart ? data.avg : data.total, isPercentChart ? 1 : 0, 1)}*/}
        {/*    </AppText>*/}
        {/*    <AppText variant={'caption'} style={{textAlign: 'right', color: ColorTheme, fontWeight: FontWeightMedium, marginLeft: 6, minWidth: 40, opacity: isPercentChart ? 1 : 0}}>*/}
        {/*      {ValueHelper.getDisplayValue(isPercentChart && data.inputCount > 0 ? data.avg/data.inputCount*100 : 0, false, 0) + "%"}*/}
        {/*    </AppText>*/}
        {/*  </View>*/}
        {/*  : null*/}
        {/*}*/}
      </Paper>
    );
  }

  onBarItemClicked = (item) => {
  }

  onChangeSelect = (event) => {
    let focusId = this.state.focusId;
    if (event.target.name === 'chartId' && focusId) {
      const newChartId = event.target.value;
      const focuses = this.props.activityInsight.configs.focuses;
      if (focuses && focuses.length > 0) {
        focuses.forEach((group) => {
          if (group.inCharts && group.inCharts.length > 0 && (!newChartId || !group.inCharts.includes(newChartId)) && group.items && group.items.length > 0) {
            group.items.forEach((item) => {
              if (item.id === focusId) {
                focusId = '';
              }
            });
          }
        });
      }
    }
    this.setState({focusId: focusId, [event.target.name]: event.target.value});
  }

  onResetClicked = () => {
    this.props.resetActivityInsight();
    this.setState({chartId: '', focusId: '', filters: null});
  }

  onFiltersClicked = () => {
    this.setState({showFilters: true});
  }

  onFiltersDeleted = () => {
    if (this.refFilterView) {
      this.refFilterView.resetFilters();
    }
    this.setState({filters: null});
  }

  onFiltersUpdated = (filters) => {
    this.setState({filters: filters, showFilters: false});
  }

  onShowInsightClicked = () => {
    this.makeApiForInsight();
  }

  onBackClicked = () => {
    navBackOrExit(this.props.history);
  };

  onRetryClicked = () => {
    if (this.props.activityInsight.configs) {
      this.makeApiForInsight();
    } else {
      this.makeApiForInsightConfig();
    }
  };

  onConfigsFetched = () => {
    // setTimeout(() => {
    //   const {activityInsight} = this.props;
    //   if (activityInsight.configs.charts && activityInsight.configs.charts.length > 0) {
    //     this.setState({
    //       chartId: activityInsight.configs.charts[0].id,
    //       focusId: activityInsight.configs.focuses[0].items[0].id
    //     }, () => {
    //       this.makeApiForInsight();
    //     });
    //   }
    // });
  }

  makeApiForInsightConfig = () => {
    if (this.isScreen) {
      this.props.fetchScreenInsightConfigs(this.activityId).then(this.onConfigsFetched);
    } else {
      this.props.fetchActivityInsightConfigs(this.activityId, this.activityType, this.showRating).then(this.onConfigsFetched);
    }
  }

  makeApiForInsight() {
    const {chartId, focusId, filters} = this.state;
    let appliedFilters = {};
    const filtersAppliedKeys = filters ? Object.keys(filters) : null;
    if (filtersAppliedKeys && filtersAppliedKeys.length > 0) {
      filtersAppliedKeys.forEach((key) => {
        if (filters[key] && filters[key].length > 0) {
          if (InsightFilterHelper.getType(key) === FILTER_TYPE_DATE) {
            appliedFilters[key] = DateTimeHelper.getApiDateOnlyStringFromDate(filters[key][0]);
          } else if (key === FILTER_INTEREST_OPTION && filters[key] && filters[key].length > 0) {
            let values = [];
            filters[key].forEach((item) => {
              if (item) {
                const itemValues = Object.values(item);
                if (itemValues && itemValues.length > 0) {
                  itemValues.forEach((value) => {
                    values.push(value);
                  });
                }
              }
            });

            appliedFilters[key] = AppUtils.implodeObjects(',', values);
          } else {
            const values = filters[key];
            appliedFilters[key] = AppUtils.implodeObjects(',', values);
          }
        }
      });
    }
    if (this.isScreen) {
      this.props.fetchScreenInsight(this.activityId, chartId, focusId, appliedFilters);
    } else {
      this.props.fetchActivityInsight(this.activityId, this.activityType, chartId, focusId, appliedFilters);
    }
  }
}

ActivityInsight.propTypes = {
  classes: PropTypes.object,
  location: PropTypes.object,
  app: PropTypes.object,
  isLoading: PropTypes.bool,
  user: PropTypes.object,
  activityInsight: PropTypes.object,
  activities: PropTypes.object,
};

ActivityInsight.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    isLoading: state.isLoading,
    activityInsight: state.admin.activityInsight,
    activities: state.admin.activities,
    user: state.admin.user,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchScreenInsightConfigs: (id) => dispatch(fetchScreenInsightConfigs(id)),
    fetchScreenInsight: (id, chartId, focusId, filters) => dispatch(fetchScreenInsight(id, chartId, focusId, filters)),

    fetchActivityInsightConfigs: (id, aType, showRating) => dispatch(fetchActivityInsightConfigs(id, aType, showRating)),
    fetchActivityInsight: (id, aType, chartId, focusId, filters) => dispatch(fetchActivityInsight(id, aType, chartId, focusId, filters)),
    resetActivityInsight: () => dispatch(resetActivityInsight()),
    sortActivityInsight: (dataIndex, sortBy) => dispatch(sortActivityInsight(dataIndex, sortBy)),
    toggleZeroInActivityInsight: (dataIndex) => dispatch(toggleZeroInActivityInsight(dataIndex)),
    toggleShowHideQnsInActivityInsight: (dataIndex) => dispatch(toggleShowHideQnsInActivityInsight(dataIndex)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isSMOnly', theme => theme.breakpoints.only('sm'), {defaultMatches: true}],
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ActivityInsight))
);
